import { Observable } from 'rxjs/Observable';
import { fetchPackages, fetchFavoritePackages } from '../utils/api';
import { PackagesApi } from '../parsers';

import {
  PACKAGES_FETCH_REQUESTED,
  FAVORITE_PACKAGES_FETCH_REQUESTED,
  packagesFetched,
  packagesFailed,
} from '../redux/packages';

import type { ActionObs, Store, Obs } from '../types';

export default function packagesEpic(action$: ActionObs, store: Store): Obs {
  return action$
    .ofType(PACKAGES_FETCH_REQUESTED, FAVORITE_PACKAGES_FETCH_REQUESTED)
    .map(action => {
      const apiFn =
        action.type === PACKAGES_FETCH_REQUESTED
          ? fetchPackages
          : fetchFavoritePackages;

      return { action, apiFn };
    })
    .switchMap(({ action: { payload: params }, apiFn }) => {
      return apiFn(params)
        .map(resp => PackagesApi.parse(resp))
        .map(({ ...response }) => {
          return packagesFetched({ ...response });
        })
        .catch(err => Observable.of(packagesFailed(err.message)));
    });
}
